import React, { useEffect, useState } from "react";
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper } from "@mui/material";
import CustomCheckbox from "../../../../components/ReportsMemberActivity/CustomCheckbox";
import MemberRowReport from "./MemberRowReport";
import data from "./MemberData"; // You can move your data to a separate file
import MemberSkeleton from "./MemberSkeleton";

const cellStyle = {
    padding: '10px 16px',
};

const MemberReportTable = () => {
    const [selectedRows, setSelectedRows] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);  // Ensure this gets called
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    const handleSelectAll = () => {
        if (selectedRows.length === data.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(data.map((row) => row.id));
        }
    };

    const handleRowToggle = (id) => () => {
        setSelectedRows((prev) =>
            prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
        );
    };

    const allSelected = selectedRows.length === data.length;
    const someSelected = selectedRows.length > 0 && !allSelected;

    return (
        
        <TableContainer component={Paper} sx={{ boxShadow: 'none', background: 'transparent' }}>
            <Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: '0 5px' }}>
                <TableHead sx={{ backgroundColor: '#DFDFDF' }}>
                    <TableRow>
                        <TableCell sx={{
                            ...cellStyle,
                            border: 'none',
                            minWidth: '32px',
                            maxWidth: '32px',
                            borderTopLeftRadius: '10px',
                            borderBottomLeftRadius: '10px'
                        }}>
                            <CustomCheckbox
                                checked={allSelected}
                                indeterminate={someSelected}
                                onChange={handleSelectAll}
                            />
                        </TableCell>
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>#</TableCell>
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left' }}>Members</TableCell>
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>Project</TableCell>
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>Application/Website</TableCell>
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left' }}>Activity</TableCell>
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>Time spent (hrs)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading
                        ? [...Array(3)].map((_, i) => <MemberSkeleton key={i} />)
                        : data.map((row) => (
                            <MemberRowReport
                                key={row.id}
                                row={row}
                                isSelected={selectedRows.includes(row.id)}
                                onSelectToggle={handleRowToggle(row.id)}
                            />
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MemberReportTable;